var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',_vm._b({attrs:{"right":_vm.backtopMarginRight,"bottom":_vm.backtopMarginBottom}},'el-backtop',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }